import React from 'react';
import * as _ from 'lodash';

import { SYSTEM_WORKER_COUNT, SYSTEM_WORK_HOUR } from '../utilities/constants';
import { ArrowDownIcon } from './icons/ArrowDownIcon';
import { TrashIcon } from './icons/TrashIcon';

export const WorkEarlyOverTime = ({
  workEarlyOverTimes,
  name,
  flag,
  callbacks,
  readOnly,
  isWorkHourModal = false,
}) => (
  <div>
    {_.map(workEarlyOverTimes, (workEarlyOverTime, index) => (
      <Line
        key={index}
        name={name}
        foreignKey={index}
        workEarlyOverTime={workEarlyOverTime}
        flag={flag}
        callbacks={callbacks}
        readOnly={readOnly}
        isWorkHourModal={isWorkHourModal}
      />
    ))}
    {!readOnly && (
      <div className='form-container__item form-list__man-hours-btn--add'>
        <button className='btn--sub' onClick={() => callbacks.add(name)}>
          入力枠を追加する
        </button>
      </div>
    )}
  </div>
);

const Line = ({
  name,
  foreignKey,
  workEarlyOverTime,
  flag,
  callbacks,
  readOnly,
  isWorkHourModal = false,
}) => (
  <div
    className={`form-container__item ${
      isWorkHourModal ? 'form-container__item--no-space' : ''
    }`}
  >
    <select
      className='form-list__select--man-hours'
      name='working_temp_person'
      value={workEarlyOverTime.working_temp_person}
      disabled={readOnly}
      onChange={e => callbacks.set(e, foreignKey, name, flag)}
    >
      {_.map(SYSTEM_WORKER_COUNT, worker => (
        <option key={worker.id} value={worker.id}>
          {worker.name} 人
        </option>
      ))}
    </select>
    <ArrowDownIcon className='icon--2_4x form-list__arrow-icon' />
    <span className='form-list__man-hours-line-text form-list__man-hours-line-text--cross'>
      ×
    </span>
    <select
      className='form-list__select--man-hours'
      name='working_temp_hour'
      disabled={readOnly}
      value={workEarlyOverTime.working_temp_hour}
      onChange={e => callbacks.set(e, foreignKey, name, flag)}
    >
      {_.map(SYSTEM_WORK_HOUR, time => (
        <option key={time.id} value={time.id}>
          {time.name} 時間
        </option>
      ))}
    </select>
    <ArrowDownIcon className='icon--2_4x form-list__arrow-icon' />
    <span
      className={`form-list__man-hours-line-result-text form-list__man-hours-line-result-text--wide ${
        readOnly ? 'form-list__man-hours-line-result-text--disabled' : ''
      } ${
        isWorkHourModal ? 'form-list__man-hours-line-result-text--bg-gray' : ''
      }`}
    >
      {'作業時刻 '}
      {workEarlyOverTime.overtime_start && workEarlyOverTime.overtime_start}
      {(workEarlyOverTime.overtime_start || workEarlyOverTime.earlytime_end) &&
        ' 〜 '}
      {workEarlyOverTime.earlytime_end && workEarlyOverTime.earlytime_end}
    </span>
    {!(foreignKey === 0 || readOnly) && (
      <button
        className='btn-icon--xs form-list__element--btn_delete'
        onClick={() => callbacks.remove(foreignKey, name)}
      >
        <TrashIcon className='icon--2_4x form-list__trash-icon' />
      </button>
    )}
  </div>
);



// WEBPACK FOOTER //
// ./src/components/WorkEarlyOverTime.jsx